import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { catskillConfig } from "./data";

export default function CatskillPage() {
  return <CityPageTemplate config={catskillConfig} />;
}